import styleInject from '../../../common/temp/pnpm_store/.pnpm/style-inject@0.3.0/pnpm_store/style-inject/dist/style-inject.es.js';

var css_248z = ".text_text__2qhaZ {\n  font-size: 12px;\n  color: currentColor;\n  line-height: 28px;\n}\n";
var styles = {"text":"text_text__2qhaZ"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=text.less.js.map
